Ext.ns('mx.Util');

mx.Util.Notifications = {
    displayedCount: 0,
    maxNotificationsCount: 7,
    animationLimit: 0,
    maxQueueSize: 60,
    queue: [],
    notify: function(config) {
        if (this.displayedCount >= this.maxNotificationsCount) {
            if (this.queue.length == this.maxQueueSize) {
                this.queue.shift(); //drop oldest notification
            }
            this.queue.push(config);
        } else {
            this.addConsiderQueue(config);
        }
    },
    //private
    onClosePopup: function() {
        this.displayedCount--;
        this.addConsiderQueue(this.queue.shift());
    },
    addConsiderQueue: function(config) {
        if (config && this.displayedCount < this.maxNotificationsCount) {
            this.add(config, this.queue.length + this.displayedCount <= this.animationLimit, this.onClosePopup);
            this.displayedCount++;
        }
    },
    add: function(config, isAnimated, onCloseCallback) {
        new Ext.ux.window.MessageWindow({
            title: config.title,
            autoDestroy: true, //default = true
            autoHeight: true,
            autoHide: true, //default = true
            bodyStyle: 'text-align:center',
            closable: true,
            help: false,
            onCloseCallback: onCloseCallback,
            onClickCallback: config.clickCallback,
            hideFx: isAnimated
                ? {
                      delay: 5000,
                      //duration: 0.25,
                      mode: 'standard', //null,'standard','custom',or default ghost
                      useProxy: false, //default is false to hide window instead
                  }
                : {
                      delay: 3500,
                      duration: 0,
                      mode: 'none',
                  },
            html: config.message,
            iconCls: config.isError ? 'x-icon-error' : 'x-icon-information',
            /*
             //optionally enable sound...see http://efattal.fr/extjs/examples/toastwindow/
             //if you want to enable sound with this
             listeners: {
             'beforerender': function(){
             Sound.enable();
             Sound.play('notify.wav');
             Sound.disable();
             }
             }
             */
            showFx: isAnimated
                ? {
                      delay: 0,
                      duration: 0.5, //defaults to 1 second
                      mode: 'standard', //null,'standard','custom',or default ghost
                      useProxy: false, //default is false to hide window instead
                  }
                : {
                      delay: 0,
                      duration: 0,
                      mode: 'none',
                  },
            width: 250, //optional (can also set minWidth which = 200 by default)
            initEvents: function() {
                Ext.ux.window.MessageWindow.prototype.initEvents.call(this);
                this.addTool({
                    id: 'close',
                    handler: this.close.createDelegate(this),
                });
            },
            listeners: {
                click: {
                    fn: function() {
                        if (this.onClickCallback) {
                            this.onClickCallback();
                        }
                    },
                },
                close: {
                    fn: function(notification) {
                        notification.manager.positions.remove(notification.pos);
                        notification.destroy();
                        notification.onCloseCallback.call(this);
                    },
                    scope: this,
                },
            },

            //-----------------overrides----------------

            animShow: function() {
                //don't update if hovering over message
                //check if visible so it will show initially
                if (this.el.isVisible() && this.el.hasClass(this.hoverCls)) {
                    return;
                }

                if (this.msgs.length > 1) {
                    this.updateMsg();
                }
                //element to hide and configured Fx
                var w = this.el,
                    fx = this.showFx || {};

                this.origin = this.origin || {};

                //apply defaults if not already configured
                Ext.applyIf(this.origin, {
                    el: Ext.getDoc(), //defaults to document
                    increment: true, //whether to increment position of subsequent messages
                    pos: 'br-br', //position to align to (see {@link Ext.Element#alignTo} for more details defaults to "br-br").
                    offX: -20, //amount to offset horizontally
                    offY: -20, //amount to offset vertically
                    spaY: 5, //vertical spacing between adjacent messages
                });

                //track positions of each instance
                this.pos = 0;

                if (this.origin.increment) {
                    while (this.manager.positions.indexOf(this.pos) > -1) {
                        this.pos++;
                    }
                    this.manager.positions.push(this.pos);
                }

                var y = this.origin.offY - (this.getSize().height + this.origin.spaY) * this.pos;

                //unused t (used for debugging)
                //        var t = this.getSize();

                //set the window size
                this.setSize(this.width || this.minWidth, this.height || this.minHeight);

                //increment the vertical position of the window
                if (this.origin.increment) {
                    y = this.origin.offY - (this.getSize().height + this.origin.spaY) * this.pos;
                } else {
                    y = 0;
                }

                w.alignTo(
                    this.origin.el, // element to align to.
                    this.origin.pos, // position to align to (see {@link Ext.Element#alignTo} for more details).
                    [this.origin.offX, y] // Offset the positioning by [x, y]:
                );

                if (fx.mode == 'none') {
                    w.show();
                    this.afterShow();
                } else {
                    w.slideIn('b', {
                        duration: fx.duration || 1,
                        callback: this.afterShow,
                        scope: this,
                    });
                }
            },
            animHide: function() {
                //remove the position of this element from the manager
                this.manager.positions.remove(this.pos);

                //element to hide and configured Fx
                var w,
                    fx = this.hideFx || {};

                //animate using a proxy instead of actual element if so configured
                if (fx.useProxy) {
                    w = this.proxy;
                    this.proxy.setOpacity(0.5);
                    this.proxy.show();
                    var tb = this.getBox(false);
                    this.proxy.setBox(tb);
                    this.el.hide();
                    Ext.apply(fx, tb);
                } else {
                    w = this.el;
                }

                Ext.applyIf(fx, {
                    block: false, //default for window is true
                    callback: this.afterHide,
                    easing: 'easeOut', //'easeNone';
                    remove: true,
                    scope: this,
                });

                switch (fx.mode) {
                    case 'none':
                        w.hide();
                        w.destroy();
                        this.afterHide();
                        break;
                    case 'slideIn':
                        w[fx.mode]('b', fx);
                        break;
                    case 'custom':
                        Ext.callback(fx.callback, fx.scope, [this, w, fx]); //callback(cb,scope,args,delay)
                        break;
                    case 'standard':
                        fx.duration = fx.duration || 0.25;
                        fx.opacity = 0;
                        w.shift(fx);
                        break;
                    default:
                        fx.duration = fx.duration || 1;
                        w.ghost('b', fx);
                        break;
                }
            },
        }).show(Ext.getDoc());
    },
};
